import React from 'react'
import MainLayout from '../layout/MainLayout'

function UserPreferences() {
    return (
        <div>
            <MainLayout>
                <h3>Notify me when:</h3>
                <input type="checkbox" name="announcements" /><label htmlFor="announcements">Special Announcements</label>
                <br /><input type="checkbox" name="newDocs" /><label htmlFor="newDocs">New Documents Arrive</label>
                <br /><input type="checkbox" name="tags" /><label htmlFor="tags">Somebody tags me</label>
                <br /><input type="checkbox" name="responce" /><label htmlFor="responce">Somebody responds to one of my comments</label>
                <br /><br />
                <button type="button">Save</button>
            </MainLayout>
        </div>
    )
}

export default UserPreferences
